type configTypes = {
  REACT_APP_BASE_URL: string;
  REACT_APP_API_MAP_KEY: string;
};

const config: configTypes = {
  REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL as string,
  REACT_APP_API_MAP_KEY: process.env.REACT_APP_API_MAP_KEY as string
};

export default config;
